import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { OrgPreApprovedStage, Spinner } from '@components';
import { AccountType, OrgStatus } from '@constants/generic';
import { HELP, PAGE_NOT_FOUND } from '@constants/routes';

import ThankyouPage from './components/ThankyouPage';

const ApprovalGuard = ({ children }: { children: React.ReactNode }) => {
  const { currentOrg, isOrgListLoading, appConfig } = useSelector(
    (state: any) => state.user
  );

  const { pathname } = useLocation();

  if ([PAGE_NOT_FOUND, HELP].includes(pathname)) return <div>{children}</div>;

  if (isOrgListLoading)
    return (
      <div className="absolute left-1/2 top-1/2 flex size-full -translate-x-1/2 -translate-y-1/2 items-center justify-center">
        <Spinner />
      </div>
    );
  if (
    currentOrg?.status === OrgStatus.PENDING &&
    currentOrg?.type === AccountType.INDIVIDUAL &&
    !!appConfig?.is_individual_manual_verification_required
  )
    return <ThankyouPage />;

  if (
    [
      OrgStatus.PENDING,
      OrgStatus.REJECTED,
      OrgStatus.VERIFICATION_SUBMITTED
    ].includes(currentOrg?.status) ||
    (currentOrg?.status === OrgStatus.KYC_SUBMITTED &&
      currentOrg?.declaration_status)
  )
    return (
      <OrgPreApprovedStage
        currentOrgStatus={currentOrg?.status}
        declarationStatus={currentOrg?.declaration_status}
      />
    );

  if (!currentOrg?.id) return null;

  return <div>{children}</div>;
};

export default ApprovalGuard;
